import { render, staticRenderFns } from "./stockInTransitBarChart.vue?vue&type=template&id=16c90406&scoped=true&"
import script from "./stockInTransitBarChart.vue?vue&type=script&lang=js&"
export * from "./stockInTransitBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c90406",
  null
  
)

export default component.exports